import React from 'react'
import '../../../styles/Conversation.css'

export default function ConversationSkeleton({ visibleChats }) {
    return (
        <div className="conversation-container">
            <div
                className="conversation-header"
                style={{
                    backgroundColor: visibleChats ? '#fafaff' : '#153c4f32',
                    minHeight: '70px',
                }}
            >
                <div className="chat-icon-circle animate-pulse" style={{ backgroundColor: '#e5e5f0', width: 40, height: 40 }}></div>
                <div className="conversation-type animate-pulse" style={{ width: 120, height: 16, backgroundColor: '#e5e5f0', borderRadius: 4 }}></div>
                <div className="conversation-close-aye" />
            </div>

            <div className="conversation-main scrollbar-none">
                <div className="conversation-grow" />
                <div className="conversation-messages">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className={`conversation-message-wrapper ${index % 2 === 0 ? 'sent-wrapper' : 'received-wrapper'} `}>
                            <div
                                className={`conversation-message ${index % 2 === 0 ? 'sent-message' : 'received-message'} animate-pulse`}
                                style={{ height: 20, borderRadius: 20, marginBottom: 10 }}
                            ></div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="new-message-input-box">
                <div className="new-message-input">
                    <div style={{ flex: 1, height: 20, borderRadius: 10 }}></div>
                    <div className="new-message-input-icon" />
                </div>
            </div>
        </div>
    )
}
